import { render } from "./TiposEventos.vue?vue&type=template&id=784a66c5"
import script from "./TiposEventos.vue?vue&type=script&lang=js"
export * from "./TiposEventos.vue?vue&type=script&lang=js"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__